module.exports = __webpack_public_path__ + "static/media/valogo.1f70e520.png";